// Psychologist/MyPsychologists.tsx

import React, {useCallback} from 'react';
import {IPsychologist} from '../../Types/psychology/psychologist';
import {axios} from 'Auth/axiosConfig';
import {FC, FRC} from 'WideLayout/Layouts';
import Button from "Core/components/elements/Button/Button";
import {useNavigate} from "react-router-dom";
import PsychologistListWrapper from "Psychologist/PsychologistListWrapper";

interface FetchMyPsychologistsResponse {
    results: IPsychologist[];
    count: number;
    next: string | null; // Если API поддерживает пагинацию
}

interface MyPsychologistsProps {
    containerRef?: React.RefObject<HTMLDivElement>;
}

const MyPsychologists: React.FC<MyPsychologistsProps> = ({containerRef}) => {
    const navigate = useNavigate();

    // Функция для загрузки "моих" психологов
    const fetchMyPsychologists = useCallback(async (page: number): Promise<FetchMyPsychologistsResponse> => {
        const response = await axios.get('/api/v1/client/psychologists/', {
            params: {page: page},
        });

        return {
            results: response.data.results
                ? response.data.results
                : response.data,
            count: response.data.count,
            next: response.data.next,
        };
    }, []);

    return (
        <PsychologistListWrapper
            containerRef={containerRef}
            fetchPsychologists={fetchMyPsychologists}
            emptyMessage={
                <FC g={1}>
                    <FRC mt={2}>
                        У вас ещё не было консультаций
                    </FRC>
                    <Button
                        className={'text-nowrap w-min mx-auto px-4'}
                        onClick={() => navigate('/psychologists')}>
                        Подобрать психолога
                    </Button>
                </FC>
            }
            showChatButton={true} // Показывать кнопку чата
            classNameContainer="maxw-700px mx-auto w-100"
            classNameScrollBar="pt-3 pb-2 px-2 fr gap-2"
        />
    );
};

export default MyPsychologists;
